import { QueryClient } from '@tanstack/react-query';

// Configure React-Query client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});
